jQuery.noConflict();

window.api = {
    vars: {
        lang: "el",

        isIE: false,
        isEdge: false,
        isIE6To11: false,
        is: "desktop",
        windW: 0,
        windH: 0,
        windOldW: 0,
        windOldH: 0,

        wresizetimer: 100,
        resizetimeout: 0,
        timerout: 0,

        IframeAPIReady: false,

        youtubeSelectors: [],
        youtube_addedScriptToHead: false,

        googleMapReady: false,

        grecaptchaIds: [],

        scr: {
            phone: 0,
            phoneSmall: 576,
            tablet: 768,
            desktop: 1025,
        },

        datepicker: {
            dateFormat: "dd/mm/yy",
        },

        selectors: {
            body: "body",
            header: ".header",
            footer: ".footer",
        },

        slick: {
            edgeFriction: 0,
            speed: 300,
            prevArrow: '<button type="button" class="slick-prev"></button>',
            nextArrow: '<button type="button" class="slick-next"></button>',
        },

        zoomLevel: 100,
    },

    detectors: {},

    fn: {},

    components: {},

    forms: {},

    resizeCommon: {},

    modules: {},

    cookies: {},

    accessibilities: {},
};
